import { render, staticRenderFns } from "./CompetitionListSearchDetailLayout.vue?vue&type=template&id=01348ef5&scoped=true"
import script from "./CompetitionListSearchDetailLayout.vue?vue&type=script&lang=js"
export * from "./CompetitionListSearchDetailLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01348ef5",
  null
  
)

export default component.exports